import { APP_CODES } from '@/const/appcodes';

export const FEATURES = {
  UPDATE_USER_CREDENTIALS: 'updateUserCredentials',
  ALLOW_CACHE_INVALIDATION: 'allowCacheInvalidation',
  DETAILED_REPORTS: 'detailedReports',
  WIDGET_SETUP: 'widgetSetup',
  WIDGET_DISCOVERY: 'widgetDiscovery',
  RICH_CONTENT: 'richContent',
  LLM_ANSWERS: 'llmAnswers',
  BOTS_DISCOVERY_POLLING: 'botsDiscoveryPolling',
  AGENT_GROUPS_SELECTION: 'agentGroupsSelection',
  INDIVIDUAL_KB_BOT_ANSWER_CONFIDENCE: 'individualKbBotAnswerConfidence',
  LLM_PROMPTS_CONFIGURATION: 'llmPromptsConfiguration',
  RECOMMENDATION_SOURCES_READ_ONLY: 'recommendationSourcesReadOnly',
  HIDE_BOT_MESSAGES_SECTION: 'hideBotMessagesSection',
};

export const CA_FEATURE_FLAGS = {
  [FEATURES.UPDATE_USER_CREDENTIALS]: 'appsConversationAsisstUpdateUserCredentialsEnabled',
  [FEATURES.ALLOW_CACHE_INVALIDATION]: 'appsConversationAssistCacheInvalidationEnabled',
  [FEATURES.DETAILED_REPORTS]: 'appsConversationAssistDetailedReportsEnabled',
  [FEATURES.WIDGET_SETUP]: 'appsConversationAssistWidgetSetupEnabled',
  [FEATURES.WIDGET_DISCOVERY]: 'appsConversationAssistWidgetDiscoveryFlowEnabled',
  [FEATURES.RICH_CONTENT]: 'appsConversationAssistRichContentEnabled',
  [FEATURES.LLM_ANSWERS]: 'appsConversationAssistKbLlmSettingEnabled',
  [FEATURES.BOTS_DISCOVERY_POLLING]: 'appsConversationAssistBotsDiscoveryPollingEnabled',
  [FEATURES.AGENT_GROUPS_SELECTION]: 'appsConversationAssistAgentGroupsSelectionEnabled',
  [FEATURES.INDIVIDUAL_KB_BOT_ANSWER_CONFIDENCE]: 'appsConversationAssistIndividualKbBotAnswerConfidenceEnabled',
  [FEATURES.LLM_PROMPTS_CONFIGURATION]: 'appsConversationAssistLlmPromptsConfigurationEnabled',
  [FEATURES.RECOMMENDATION_SOURCES_READ_ONLY]: 'appsConversationAssistRecommendationSourcesReadOnlyEnabled',
  [FEATURES.HIDE_BOT_MESSAGES_SECTION]: 'appsConversationAssistHideBotMessagesSectionEnabled',
};

export const CA_FEATURE_FLAGS_TRANSFORMED = {
  [APP_CODES.CONVERSATION_ASSIST]: 'appsConversationAssistEnabled',
  [FEATURES.DETAILED_REPORTS]: 'appsConversationAssistDetailedReportsEnabled',
  [FEATURES.WIDGET_SETUP]: 'appsConversationAssistWidgetSetupEnabled',
};
